package com.wintermar.inspection.feature.domain.model.answer

data class AnswerLocationModel(
    val id: String = "",
    val answerId: String = "",
    val name: String = "",
    val latitude: Double = 0.0,
    val longitude: Double = 0.0,
    val street: String = "",
    val isoCountryCode: String = "",
    val country: String = "",
    val postalCode: String = "",
    val administrativeArea: String = "",
    val subAdministrativeArea: String = "",
    val locality: String = "",
    val subLocality: String = "",
    val thoroughfare: String = "",
    val subThoroughfare: String = ""
)
